import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Tag,
  Typography,
} from "@suraasa/placebo-ui"
import capitalize from "lodash/capitalize"
import startCase from "lodash/startCase"
import { pluralize } from "utils/helpers"

import { WarningType } from "../../Proctoring"

type Props = {
  open: boolean
  handleClose: () => void
  // parentSelector?: () => void
  onSubmit: () => void
  unattemptedQuestionsCount: number
  unreadQuestionsCount: number
  markedForReviewQuestionCount: number
  warnings?: WarningType
  totalWarnings?: number
}

const SubmitConfirmationDialog = ({
  open,
  warnings,
  // parentSelector,
  unattemptedQuestionsCount,
  unreadQuestionsCount,
  markedForReviewQuestionCount,
  onSubmit,
  totalWarnings,
  handleClose,
}: Props) => {
  const warningDisplay = Object.entries(warnings || {}).map(e => ({
    name: capitalize(startCase(e[0])),
    value: e[1],
  }))

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Typography variant="subtitle2">Submit Assessment?</Typography>
          </DialogTitle>
        </DialogHeader>

        <DialogBody>
          <Typography className="mb-1.25">
            Are you sure you want to submit the assessment? This action cannot
            be reversed.
            {(unattemptedQuestionsCount > 0 ||
              unreadQuestionsCount > 0 ||
              markedForReviewQuestionCount > 0) &&
              "\n\nYou still have:"}
          </Typography>
          <div className="mb-1.25 flex flex-wrap gap-1">
            {markedForReviewQuestionCount > 0 && (
              <Tag color="warning" size="md">
                {`${pluralize(
                  "Question",
                  markedForReviewQuestionCount
                )} Marked for Review`}
              </Tag>
            )}
            {unattemptedQuestionsCount > 0 && (
              <Tag color="critical" size="md">
                {`${pluralize(
                  "Question",
                  unattemptedQuestionsCount
                )} Unanswered`}
              </Tag>
            )}
            {unreadQuestionsCount > 0 && (
              <Tag color="onSurface" size="md">
                {`${pluralize("Question", unreadQuestionsCount)} Unread`}
              </Tag>
            )}
          </div>

          {Boolean(totalWarnings) && (
            <div className="mt-2 border-t-2 pt-1">
              <Typography variant="largeBody" className="mb-0.5">
                Total Violations: {totalWarnings}
              </Typography>
              {warningDisplay.map(e =>
                e.value > 0 ? (
                  <Typography
                    key={e.name}
                    variant="smallBody"
                    className="text-onSurface-500"
                  >
                    {e.name}: {e.value}
                  </Typography>
                ) : null
              )}
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          <Button color="black" type="submit" onClick={onSubmit}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SubmitConfirmationDialog
